<template>
  <b-modal
    :id="`modal-reset-email-${key_id}`"
    centered
    title="重設電郵"
    hide-footer
  >
    <b-card no-body>
      <!-- form -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form
            class="auth-form"
            @submit.prevent="handleSubmit(resetEmailForm)"
          >
            <validation-provider
              #default="{ errors }"
              vid="v_email"
              name="此欄"
              rules="required|email"
            >
              <b-form-group class="required" label="電郵：">
                <b-input-group>
                  <b-form-input
                    id="forgot-password-email"
                    v-model="newResetData.email"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="輸入電郵"
                  />
                  <b-input-group-append is-text>
                    <b-button
                      variant="primary"
                      class="p-50"
                      @click="sendChangeEmailVertificationCode"
                    >
                      發送驗證碼
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <!--             <validation-provider
                    #default="{ errors }"
                    name="密碼"
                    vid="password"
                    rules="required"
                  >
                    <b-form-group class="required mt-1" label="密碼：">
                      <b-form-input
                        id="password"
                        type="password"
                        placeholder="輸入密碼"
                        v-model="newResetData.password"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider
                    #default="{ errors }"
                    name="確認密碼"
                    vid="c_password"
                    rules="required"
                  >
                    <b-form-group class="required" label="確認密碼：">
                      <b-form-input
                        id="c_password"
                        type="password"
                        placeholder="輸入確認密碼"
                        v-model="newResetData.c_password"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider> -->

            <validation-provider
              #default="{ errors }"
              vid="v_vertification_code"
              name="此欄"
              rules="required"
            >
              <b-form-group class="required" label="驗證碼：">
                <b-form-input
                  id="vaildate"
                  placeholder="輸入驗證碼"
                  v-model="newResetData.vertification_code"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <div>
              <b-button type="submit" variant="primary" block class="">
                提交
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BLink,
  BOverlay,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ref, watch } from "@vue/composition-api";

import axiosIns from "@/libs/axios";

export default {
  components: {
    VuexyLogo,
    BModal,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCard,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    resetData: {
      type: Object,
      required: true,
    },
    key_id: {},
  },
  data() {
    return {
      required,
      email,
    };
  },
  computed: {
    imgUrl() {},
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-reset-email-navbar");
    },
    handleLogout() {
      //Request server to void the token
      axiosIns.get("/logout");
      localStorage.clear();
      // localStorage.setItem("isWarningShow", 1);
      //Reqired to login page
      //Show the success message
      this.$router.replace("/login").then(() => {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `成功`,
            icon: "CoffeeIcon",
            variant: "success",
            text: `您已成功退出！`,
          },
        });
      });
    },
    resetEmailForm() {
      this.loading = true;
      axiosIns
        .post("/resetemail_with_code", this.newResetData)
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });

          this.hide();
          this.loading = false;
          this.handleLogout();
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$swal({
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
    sendChangeEmailVertificationCode() {
      this.loading = true;
      axiosIns
        .post("/sendChangeEmailVertificationCode", {
          email: this.newResetData.email,
        })
        .then((response) => {
          this.$swal({
            text: response.data.message,
            icon: "success",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$swal({
            text: err.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
    },
  },
  setup() {
    const newResetData = ref({});
    const loading = ref(false);

    const resetInvoiceData = () => {
      newResetData.value = {
        email: "",
        password: "",
        c_password: "",
        vertification_code: "",
      };
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetInvoiceData);

    return {
      newResetData,
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
#forgot-password-email {
  border-radius: 0.357rem 0 0 0.357rem;
}
.auth-form {
  label {
    font-size: 14px;
  }
}
.input-group-text {
  padding: 0rem 0.5rem;
}
</style>
